import { render, staticRenderFns } from "./Chaldal.vue?vue&type=template&id=02f289c9&scoped=true&"
import script from "./Chaldal.vue?vue&type=script&lang=js&"
export * from "./Chaldal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f289c9",
  null
  
)

export default component.exports